export { bankCustomerVendorRoutingNode } from './routes/route'
